import { t } from "@/i18n-js/instance";
import type { SelectedCategory } from "../TemplateContents";
import { NavigationItem } from "./NavigationItem";

const localeNamespace = "settings.emails.templates";

export const NavigationList = ({
  activeId,
  navigationItems,
  onClickNavItem,
}: {
  activeId: SelectedCategory;
  navigationItems: SelectedCategory[];
  onClickNavItem: (id: SelectedCategory) => void;
}) => {
  const isActive = (id: SelectedCategory) => activeId === id;

  return (
    <nav>
      <ul className="list-none space-y-1">
        {navigationItems.map((item, index) => (
          <NavigationItem
            key={item}
            label={t([localeNamespace, item])}
            isActive={isActive(item)}
            onClick={() => onClickNavItem(item)}
            isComingSoon={false}
            withDivider={index === 0}
          />
        ))}
      </ul>
    </nav>
  );
};
